import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTranslation } from 'react-i18next';

const RoomsAvailability = () => {
  const [rooms, setRooms] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { t, i18n } = useTranslation();

  const incrementRooms = () => setRooms(prev => prev + 1);
  const decrementRooms = () => setRooms(prev => (prev > 1 ? prev - 1 : 1));

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div 
      className="selector border-1 p-2 room-select-box position-relative"
      ref={dropdownRef}
      dir={i18n.language === "ar" ? "rtl" : "ltr"} // RTL support
    >
      <div 
        className="position-relative w-100 d-flex align-items-center justify-content-between"
        onClick={() => setDropdownOpen(!dropdownOpen)} 
        style={{ cursor: 'pointer' }}
      >
        <span className="d-block mb-0">{t("rooms")}</span>
        <div className="btn-arrow-top-bottom mb-0 d-flex align-items-center">
          <span className="arrow p-0 m-0 me-2">
            <svg width="13" height="7" viewBox="0 0 13 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 6.5L6.5 1L12 6.5" stroke="#F49B31" strokeLinecap="round" />
            </svg>
          </span>
          <span>{rooms}</span>
        </div>
      </div>

      {dropdownOpen && (
        <div 
          className="dropdown position-absolute bg-white border p-3 mt-0 d-block"
          style={{ zIndex: 100, width: '100%' }}
        >
          <div className="dropdown-row d-flex align-items-center justify-content-between">
            <span>{t("rooms")}</span>
            <div className="counter btn-group">
              <button className="btn btn-outline-primary p-0" onClick={decrementRooms}>-</button>
              <span className="px-3">{rooms}</span>
              <button className="btn btn-outline-primary p-0" onClick={incrementRooms}>+</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RoomsAvailability;
